import * as React from "react";
import { useSelector } from "react-redux";

import { Annotation } from "@com.mgmtp.a12.base/base-model-api/lib/main/header";
import { UaaSelectors } from "@com.mgmtp.a12.uaa/uaa-authentication-client";

import { isAdmin, isUser, selectPermissionsForFv } from "../utilities/user";
import { VISIBILITY_SCOPE } from "../utilities/variables/modulfRuntimeAnnotations";

import { getDecoratorComponentName } from "./inputAriaRequiredDecorator";

/**
 * Decorator, der eine React-Componente nur dann anzeigt, wenn der benötigte Scope aus der annotation für das Fachverfahren vorhanden ist.
 * @param Component React-Component, die bei nicht vorhandenen Scope ausgeblendet werden soll.
 * @param annotationSelector Funktion, die die Props auf die Annotationen der Component abbildet.
 * @param fvKey Fachverfahrens Key, für den der Scope überprüft werden soll.
 * @constructor
 */
export function ScopeBasedVisibilityDecorator<T>(
	Component: React.ComponentType<T>,
	annotationSelector: (props: T) => readonly Annotation[] | undefined,
	fvKey?: string
) {
	const displayName = getDecoratorComponentName(Component, ScopeBasedVisibilityDecorator);

	function ComponentWrapper(props: T & React.JSX.IntrinsicAttributes) {
		const fvPermissions = useSelector(selectPermissionsForFv(fvKey));
		const user = useSelector(UaaSelectors.user);
		const annotations = annotationSelector(props);
		const requiredFvScope = annotations?.find(it => it.name === VISIBILITY_SCOPE)?.value;

		if (!requiredFvScope || fvPermissions.includes(requiredFvScope) || (isUser(user) && isAdmin(user))) {
			return <Component {...props} />;
		}
		return <></>;
	}

	return Object.assign(ComponentWrapper, { displayName: displayName });
}
